
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import ServicoTituloFinanceiroReceber from '@/servicos/Financeiro/ServicoTituloFinanceiroReceber';
import ServicoTituloFinanceiroPagar from '@/servicos/Financeiro/ServicoTituloFinanceiroPagar';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';

export default defineComponent({
  name: 'SelecionarMarcadorTituloFinanceiro',
  props: {
    marcadoresSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite para definir um marcador',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: Number,
      required: true,
    },
  },
  emits: ['update:marcadoresSelecionados'],
  setup(props, { emit }) {
    let debounce = 0;
    const servicoTituloFinanceiroPagar = new ServicoTituloFinanceiroPagar();
    const servicoTituloFinanceiroReceber = new ServicoTituloFinanceiroReceber();

    const state = reactive({
      listaMarcadores: [] as IOptionString[],
    });

    const computedMarcadoresSelecionados = computed({
      get: () => props.marcadoresSelecionados,
      set: (valor: string[]) => {
        emit('update:marcadoresSelecionados', valor);
      },
    });

    async function pesquisarMarcador(valorPesquisa: any) {
      state.listaMarcadores = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        let marcadoresApi = [] as string[];
        if (props.tipo === ETipoTituloFinanceiro.Pagar) {
          marcadoresApi = await servicoTituloFinanceiroPagar.consultarMarcadores(valorPesquisa);
        } else {
          marcadoresApi = await servicoTituloFinanceiroReceber.consultarMarcadores(valorPesquisa);
        }
        marcadoresApi.forEach((marcador) => {
          const optionMarcador:IOptionString = { value: marcador, label: marcador };
          state.listaMarcadores.push(optionMarcador);
        });
      }, 600);
    }

    return {
      props,
      state,
      pesquisarMarcador,
      computedMarcadoresSelecionados,
    };
  },
});
